module.exports = __webpack_public_path__ + "static/img/menu1.891fffe8.png";